export const ADD_CONTACT = '@@firedrum/ADD_CONTACT'
